"use client";

import { Trans } from "react-i18next/TransWithoutContext";
import { useClientTranslation } from "@rimo/frontend/hooks/i18n/useClientTranslation";

import React from "react";
import { PoliciesContainerStyle, styleForPolicies } from "../styles/policiesPage";
import { SimpleLayout } from "../components/layouts/SimpleLayout";
import { usePageView } from "../hooks/useGtag";
import { Footer } from "./genericLP/Footer";

export const Scta: React.FC = () => {
  const { customT } = useClientTranslation();

  usePageView();

  return (
    <SimpleLayout themeEnabled={true}>
      <PoliciesContainerStyle>
        <h1 id={customT("特定商取引法に基づく表記")}>{customT("特定商取引法に基づく表記")}</h1>
        <h3 id={customT("アプリ名")}>{customT("アプリ名")}</h3>
        <p>{customT("Rimo Voice")}</p>
        <h3 id={customT("事業者名")}>{customT("事業者名")}</h3>
        <p>{customT("Rimo合同会社")}</p>
        <h3 id={customT("代表者")}>{customT("代表者")}</h3>
        <p>{customT("相川 直視")}</p>
        <h3 id={customT("所在地")}>{customT("所在地")}</h3>
        <p>{customT("東京都渋谷区恵比寿4丁目20番3号恵比寿ガーデンプレイスタワー18階")}</p>
        <h3 id={customT("問い合わせ")}>{customT("問い合わせ")}</h3>
        <p>
          <Trans
            i18nKey="<a href='mailto:support@rimo.app'>support@rimo.app</a>にお問い合わせください。 <br />※弊社電話番号はお客様からのご要望に基づき遅滞なく電子メールにて通知いたします。弊社電話番号が必要なお客様は上記メールよりお申し出ください。"
            components={{ a: <a> </a> }}
          />
        </p>
        <h3 id={customT("利用料")}>{customT("利用料")}</h3>
        <p>
          {customT("購入手続きの際に画面に表示されます。 特段の記載の無い限り、消費税は内税として表示しております。")}
        </p>
        <h3 id={customT("利用料以外の必要料金")}>{customT("利用料以外の必要料金")}</h3>
        <p>
          {customT(
            "サイト閲覧、コンテンツのダウンロード、お問い合わせなどの際に必要となるインターネット接続料金、通信料等。"
          )}
        </p>
        <h3 id={customT("サービスが利用可能になる時期")}>{customT("サービスが利用可能になる時期")}</h3>
        <p>{customT("購入ページに特別の表記がある場合を除き、購入取引完了後直ちにご利用いただけます。")}</p>
        <h3 id={customT("お支払い方法")}>{customT("お支払い方法")}</h3>
        <ul>
          <li>{customT("クレジットカード決済")}</li>
          <li>{customT("請求書払い")}</li>
        </ul>
        <h3 id={customT("返品交換キャンセル等")}>{customT("返品・交換・キャンセル等")}</h3>
        <p>
          <Trans i18nKey="電子商品としての性質上、返品/キャンセルできかねます。あらかじめ、提供サービスの内容、動作環境等をよくお確かめの上ご購入ください。 <br />ただし、アプリケーションに音声認識の精度が低いといったことではない明確な不具合が発見された場合は、お問い合わせいただくことでアプリケーションのアップデートまたはその他適切な方法で修正し、提供いたします。" />
        </p>
        <h3 id={customT("サブスクリプションに関する事項")}>{customT("サブスクリプションに関する事項")}</h3>
        <ul>
          <li>{customT("サブスクリプション形式で提供されるサービスは、月額または年額の自動更新方式です。")}</li>
          <li>{customT("サブスクリプション契約は、指定された支払い方法で定期的に自動課金されます。")}</li>
          <li>
            {customT(
              "キャンセルはいつでも可能ですが、すでに支払われた期間の料金の返金はいたしません。キャンセルを希望される場合は、次回の課金日の前日までにお手続きください。"
            )}
          </li>
        </ul>
        <h3 id={customT("動作環境")}>{customT("動作環境")}</h3>
        <p>
          <Trans
            i18nKey="サービスをご利用いただくために必要な動作環境は、 サービスの <a href='https://guide.rimo.app/ja/articles/8835901-%E6%8E%A8%E5%A5%A8%E7%92%B0%E5%A2%83'>ヘルプページ </a>にて表示いたします。"
            components={{ a: <a> </a> }}
          />
        </p>
        <style>{customT(styleForPolicies)}</style>
      </PoliciesContainerStyle>
      <Footer variant="simple" showHelp />
    </SimpleLayout>
  );
};
